import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageAviaComponent} from "./pages/avia/avia.component";
import {PageAviaDetailsComponent} from "./pages/avia-details/avia-details.component";


const childrenRouts = [
  {
    path: 'new/search/avia',
    component: PageAviaComponent,
    data: {title: 'Поиск авиа'}
  },
  // {
  //   path: 'new/avia/details/:id',
  //   component: PageAviaDetailsComponent,
  //   data: {title: 'Детали перелета'}
  // }
]

const
  routes: Routes = [
    {
      path: ':lang',
      children: childrenRouts,
    },
    {
      path: '',
      children: childrenRouts,
    }
  ];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {useHash: false})
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
